/* ═══════════════════════════════════════════════════════════════
   ring-edit-pdp.js — Arc Dept. The Ring Edit
   ═══════════════════════════════════════════════════════════════ */

(function () {
  'use strict';

  /* ── State ── */
  const state = {
    aesthetic:     null,   // 'clean-boy', 'streetwear', etc.
    aestheticName: null,   // 'Clean Boy', 'Streetwear', etc.
    size:          null,   // 'S', 'M', 'L'
  };

  /* ── Element refs (resolved once on DOMContentLoaded) ── */
  let selStyle, selSize, styleConfirm,
      atcBtn, atcForm, propAesthetic, propSize,
      stickyEl, stickyStatus, stickyBtn,
      styleTiles, sizeBtns;

  /* ════════════════════════════════
     Set text on all .re-atc-btn elements (inline + sticky)
  ════════════════════════════════ */
  function setAtcText(text) {
    document.querySelectorAll('.re-atc-btn').forEach(function (btn) {
      const textEl = btn.querySelector('.re-atc-btn__text');
      if (textEl) textEl.textContent = text;
      else btn.textContent = text;
    });
  }

  /* ════════════════════════════════
     Sync ATC button state
  ════════════════════════════════ */
  function syncAtcState() {
    const ready = state.aesthetic && state.size;

    /* Summary list */
    if (selStyle) selStyle.textContent = state.aestheticName || '—';
    if (selSize)  selSize.textContent  = state.size           || '—';

    /* Hidden form inputs */
    if (propAesthetic) propAesthetic.value = state.aestheticName || '';
    if (propSize)      propSize.value      = state.size          || '';

    /* Button label — show identity-committed text as soon as aesthetic is chosen */
    let label;
    if (!state.aesthetic) {
      label = 'Select your aesthetic above';
    } else {
      label = 'Get My ' + state.aestheticName + ' Ring Edit';
    }

    setAtcText(label);

    if (atcBtn) {
      atcBtn.disabled = !ready;
      atcBtn.setAttribute('aria-disabled', String(!ready));
    }
    if (stickyBtn) {
      stickyBtn.disabled = !ready;
    }

    /* Sticky bar status */
    if (stickyStatus) {
      if (!state.aesthetic) {
        stickyStatus.textContent = 'Choose your aesthetic above to begin';
      } else if (!state.size) {
        stickyStatus.textContent = state.aestheticName + ' selected — choose your hand size';
      } else {
        stickyStatus.textContent = state.aestheticName + ' · Size ' + state.size;
      }
    }
  }

  /* ════════════════════════════════
     Style tile interaction
  ════════════════════════════════ */
  function onStyleTileClick(e) {
    const btn = e.currentTarget;
    const id   = btn.dataset.style;
    const name = btn.dataset.styleName;

    state.aesthetic     = id;
    state.aestheticName = name;

    /* Update ARIA + active class on tiles */
    styleTiles.forEach(function (t) {
      const active = (t.dataset.style === id);
      t.setAttribute('aria-checked', String(active));
      t.classList.toggle('re-style-tile--selected', active);
    });

    /* Confirmation line under grid */
    if (styleConfirm) {
      styleConfirm.textContent = '✔ ' + name + ' — curating your edit';
    }

    /* Section 03 intro — dynamic post-selection */
    const editIntro = document.querySelector('.re-edit-intro');
    if (editIntro && name) {
      editIntro.textContent =
        'Your ' + name + ' edit contains 5 hand-selected vintage rings. ' +
        'We select each piece for the ' + name + ' direction. You wear the result.';
    }

    /* Cross-sell — dynamic post-selection */
    const crosssellEl = document.querySelector('.re-crosssell__dynamic');
    if (crosssellEl && name) {
      crosssellEl.textContent =
        'Complete the look. The Signature — chain, ring, bracelet, built for your ' +
        name + ' aesthetic. $60.';
    }

    syncAtcState();

    /* Scroll to size section */
    const sizeSection = document.getElementById('re-size');
    if (sizeSection) {
      setTimeout(function () {
        sizeSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 220);
    }
  }

  /* ════════════════════════════════
     Size button interaction
  ════════════════════════════════ */
  function onSizeBtnClick(e) {
    const btn  = e.currentTarget;
    const size = btn.dataset.size;

    state.size = size;

    sizeBtns.forEach(function (b) {
      const active = (b.dataset.size === size);
      b.setAttribute('aria-checked', String(active));
      b.classList.toggle('re-size-btn--selected', active);
    });

    syncAtcState();
  }

  /* ════════════════════════════════
     Cart AJAX submit
  ════════════════════════════════ */
  function onFormSubmit(e) {
    e.preventDefault();

    const variantInput = document.getElementById('re-variant-id');
    if (!variantInput) { atcForm.submit(); return; }

    const payload = {
      id:         variantInput.value,
      quantity:   1,
      properties: {
        'Aesthetic':  state.aestheticName || '',
        'Hand Size':  state.size          || '',
      },
    };

    atcBtn.disabled = true;
    if (stickyBtn) stickyBtn.disabled = true;
    setAtcText('Adding…');

    fetch('/cart/add.js', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body:    JSON.stringify(payload),
    })
      .then(function (r) {
        if (!r.ok) throw new Error('cart/add failed');
        return r.json();
      })
      .then(function () {
        /* Notify theme cart drawer / mini-cart */
        document.dispatchEvent(new CustomEvent('cart:add',     { bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));

        /* Also try Shopify theme events used by Dawn / Impulse */
        document.dispatchEvent(new CustomEvent('theme:cart:open', { bubbles: true }));
      })
      .catch(function () {
        /* Fallback: native form submit */
        atcForm.submit();
      })
      .finally(function () {
        syncAtcState();
      });
  }

  /* ════════════════════════════════
     Sticky bar — show after hero scrolls out
  ════════════════════════════════ */
  function initStickyObserver() {
    const hero = document.getElementById('re-hero');
    if (!hero || !stickyEl) return;

    const io = new IntersectionObserver(
      function (entries) {
        const heroVisible = entries[0].isIntersecting;
        stickyEl.classList.toggle('re-sticky--visible', !heroVisible);
        stickyEl.setAttribute('aria-hidden', String(heroVisible));
      },
      { threshold: 0 }
    );
    io.observe(hero);
  }

  /* ════════════════════════════════
     Scroll reveal
  ════════════════════════════════ */
  function initReveal() {
    const reveals = document.querySelectorAll('.arc-ring-edit-pdp .re-reveal');
    if (!reveals.length) return;

    const io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('re-reveal--visible');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
    );
    reveals.forEach(function (el) { io.observe(el); });
  }

  /* ════════════════════════════════
     Init
  ════════════════════════════════ */
  document.addEventListener('DOMContentLoaded', function () {
    const root = document.querySelector('.arc-ring-edit-pdp');
    if (!root) return;

    /* Refs */
    selStyle     = document.getElementById('re-sel-style');
    selSize      = document.getElementById('re-sel-size');
    styleConfirm = document.getElementById('re-style-confirm');
    atcBtn       = document.getElementById('re-atc-btn');
    atcForm      = document.getElementById('re-add-form');
    propAesthetic = document.getElementById('re-prop-aesthetic');
    propSize      = document.getElementById('re-prop-size');
    stickyEl      = document.getElementById('re-sticky');
    stickyStatus  = document.getElementById('re-sticky-status');
    stickyBtn     = document.getElementById('re-sticky-btn');

    styleTiles = Array.from(root.querySelectorAll('.re-style-tile'));
    sizeBtns   = Array.from(root.querySelectorAll('.re-size-btn'));

    /* Event listeners */
    styleTiles.forEach(function (t) {
      t.addEventListener('click', onStyleTileClick);
      t.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onStyleTileClick(e);
        }
      });
    });
    sizeBtns.forEach(function (b) { b.addEventListener('click', onSizeBtnClick); });
    if (atcForm) atcForm.addEventListener('submit', onFormSubmit);

    /* Observers */
    initStickyObserver();
    initReveal();

    /* Initial state render */
    syncAtcState();
  });

})();
